/*
 * @bot-written
 *
 * WARNING AND NOTICE
 * Any access, download, storage, and/or use of this source code is subject to the terms and conditions of the
 * Full Software Licence as accepted by you before being granted access to this source code and other materials,
 * the terms of which can be accessed on the Codebots website at https://codebots.com/full-software-licence. Any
 * commercial use in contravention of the terms of the Full Software Licence may be pursued by Codebots through
 * licence termination and further legal action, and be required to indemnify Codebots for any loss or damage,
 * including interest and costs. You are deemed to have accepted the terms of the Full Software Licence on any
 * access, download, storage, and/or use of this source code.
 *
 * BOT WARNING
 * This file is bot-written.
 * Any changes out side of "protected regions" will be lost next time the bot makes any changes.
 */
// % protected region % [Add any extra imports here] off begin
// % protected region % [Add any extra imports here] end

export default class InputsHelper {
	// % protected region % [Customise getAriaDescribedBy here] off begin
	public static getAriaDescribedBy(id: string, tooltip?: string, subDescription?: string) {
		const tooltipId = `${id}-tooltip`;
		const subDescriptionId = `${id}-sub-description`;

		if (tooltip) {
			return tooltipId;
		}

		return subDescription ? subDescriptionId : undefined;
	}
	// % protected region % [Customise getAriaDescribedBy here] end

	// % protected region % [Customise getAriaLabel here] off begin
	public static getAriaLabel(label: React.ReactNode, labelVisible: boolean | undefined): string | undefined {
		if (labelVisible === false && typeof label === 'string') {
			return label;
		}

		return undefined;
	}
	// % protected region % [Customise getAriaLabel here] end

	// % protected region % [Add any extra methods here] off begin
	// % protected region % [Add any extra methods here] end
}
